<section id="services" class="services-section">
  <div class="container">
    <div class="section-head text-center">
      <h2>laundry made simple</h2>
      <p>From everyday wash-and-fold to premium garment care, dryo helps you spend less time on chores and more time living.</p>
    </div>

    <div class="row services-grid">
      <div class="col-md-3 col-sm-6 service-item">
        <div class="service-content">
          <mat-icon class="service-icon" aria-hidden="true">dry_cleaning</mat-icon>
          <h3>dry cleaning</h3>
          <p>Professional care for workwear, formal wear, and delicate fabrics that need extra attention.</p>
        </div>
      </div>
      
      <div class="col-md-3 col-sm-6 service-item">
        <div class="service-content">
          <mat-icon class="service-icon" aria-hidden="true">local_laundry_service</mat-icon>
          <h3>wash & fold</h3>
          <p>Freshly cleaned, folded, and ready to wear with reliable next-day turnaround.</p>
        </div>
      </div>
      
      <div class="col-md-3 col-sm-6 service-item">
        <div class="service-content">
          <mat-icon class="service-icon" aria-hidden="true">local_shipping</mat-icon>
          <h3>pickup & delivery</h3>
          <p>Schedule on your time and we handle the rest, right from your door to your closet.</p>
        </div>
      </div>
      <div class="col-md-3 col-sm-6 service-item">
        <div class="service-content">
          <mat-icon class="service-icon" aria-hidden="true">iron</mat-icon>
          <h3>steam & press</h3>
          <p>Crisp finishing for shirts, uniforms, and everyday essentials with a polished look.</p>
        </div>
      </div>
    </div>
  </div>
</section>
